var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    { staticClass: "c-mobile-menu__item" },
    [
      _c(
        "button",
        {
          staticClass: "c-mobile-menu__item__button",
          attrs: {
            id: "item-" + _vm.id,
            "aria-controls": "content-" + _vm.id,
            "aria-expanded": _vm.expanded ? "true" : "false"
          },
          on: {
            click: function($event) {
              _vm.expanded = !_vm.expanded
            }
          }
        },
        [
          _c(
            "span",
            [
              _c("v-icon", { attrs: { name: _vm.icon, size: "s" } }),
              _vm._v(" "),
              _c("span", { staticClass: "c-mobile-menu__item__button-text" }, [
                _vm._v(_vm._s(_vm.name))
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c("v-icon", {
            class: [
              { "c-mobile-menu__item__arrow--active": _vm.expanded },
              "c-mobile-menu__item__arrow"
            ],
            attrs: { name: "icon-chevron", size: "xs" }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("Transition", { attrs: { name: "fade" } }, [
        _vm.expanded
          ? _c(
              "ul",
              {
                staticClass: "c-mobile-menu__sublist",
                attrs: { id: "content-" + _vm.id }
              },
              _vm._l(_vm.items, function(subitem, subindex) {
                return _c(
                  "li",
                  {
                    key: subindex,
                    class: [
                      "c-mobile-menu__subitem",
                      { "c-mobile-menu__subitem--active": subitem.isActive }
                    ]
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "c-mobile-menu__link",
                        attrs: { href: subitem.url }
                      },
                      [_c("span", [_vm._v(_vm._s(subitem.name))])]
                    )
                  ]
                )
              }),
              0
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }